import React, { memo } from 'react';
import TransitionButton from '../molecules/TransitionButton';
import { loan_types, modernization_funds_complete_disp_type } from '../Const';

interface Props {
  reception_cd: string;
  reception_id: number;
  is_change_modernization_funds?: boolean;
  disp_type: string | null;
  item_id: string | null;
}

// 近代化資金入力種別選択へ戻るボタン
const ModernizationFundsInputTypeSelectReturn: React.FC<Props> = ({
  reception_cd,
  reception_id,
  is_change_modernization_funds,
  disp_type,
  item_id,
}) => {
  // 近代化資金入力種別選択画面へ遷移する
  const handleClickReturnButton = () => {
    location.href = `${location.origin}${process.env.MIX_MOCK_URL}/modernization_funds/input_type_select/${reception_cd}/${reception_id}`;
  };

  // 戻るボタンのJSXをセットする
  const setReturnButton = () => {
    // 借入申込変更の完了の場合は表示
    if (
      disp_type === modernization_funds_complete_disp_type.change_borrowing_application ||
      (item_id === loan_types.modernization_funds && is_change_modernization_funds)
    ) {
      return <TransitionButton label="戻る" handleClick={handleClickReturnButton} />;
    } else {
      return <></>;
    }
  };

  return <>{setReturnButton()}</>;
};

export default memo(ModernizationFundsInputTypeSelectReturn);
